import { Presenter } from '@app/presenters';
import { isObject } from 'lodash-es';

export function toFormData(object, parentKey?, formData = new FormData()): FormData {
    let index = 0;

    for (const key in object) {
        if (object.hasOwnProperty(key)) {
            const value = object[key];

            if (key === '$presenter' || key.charAt(0) === '$' || value instanceof Presenter) {
                continue;
            }

            if (value !== null && value !== undefined) {
                let propName = parentKey || key;

                if (parentKey && isObject(object)) {
                    propName = `${parentKey}[${key}]`;
                }

                if (parentKey && Array.isArray(object)) {
                    propName = `${parentKey}[${index}]`;
                }

                if (value instanceof File) {
                    formData.append(propName, value, value.name);
                } else if (value instanceof FileList) {
                    for (let j = 0; j < value.length; j++) {
                        const file = value.item(j);

                        formData.append(`${propName}[${j}]`, file, file.name);
                    }
                } else if (Array.isArray(value) || isObject(value)) {
                    toFormData(value, propName, formData);
                } else if (typeof value === 'boolean') {
                    formData.append(propName, value ? '1' : '0');
                } else {
                    formData.append(propName, value);
                }
            }
        }

        index++;
    }

    return formData;
}

/**
 * Only convert to FormData if a file is included.
 * @param object
 * @return {FormData|object}
 */
export function toFormDataIfNeeded(object) {
    const formData = toFormData(object) as any;

    for (const value of formData.values()) {
        if (value instanceof File) {
            return formData;
        }
    }

    return object;
}


